import { useMantineTheme } from "@mantine/core";
import { useViewportSize } from "@mantine/hooks";
import { useEffect, useState } from "react";

const useIsAtBreakpoint = (breakpoint: string) => {
  const { width } = useViewportSize();
  const [isAtBreakpoint, setIsAtBreakpoint] = useState(false);

  const createDummyElement = (value: string) => {
    const dummy = document.createElement("div");
    dummy.style.width = value;
    dummy.style.position = "absolute";
    dummy.style.visibility = "hidden";
    document.body.appendChild(dummy);
    const width = dummy.offsetWidth;
    document.body.removeChild(dummy);
    return width;
  };

  useEffect(() => {
    const handleResize = () => {
      const breakpointWidth = createDummyElement(breakpoint);
      setIsAtBreakpoint(width < breakpointWidth);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoint, width]);

  return isAtBreakpoint;
};

export const useIsLargeScreen = () => {
  const theme = useMantineTheme();
  return useIsAtBreakpoint(theme.breakpoints.lg);
};

export const useIsMediumScreen = () => {
  const theme = useMantineTheme();
  return useIsAtBreakpoint(theme.breakpoints.sm);
};

export const useIsSmallScreen = () => {
  const theme = useMantineTheme();
  return useIsAtBreakpoint(theme.breakpoints.xs);
};
